import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "type", "htmlType", "as", "responsive", "color", "className", "style", "truncate"];
import { forwardRef } from 'react';
import cn from 'classnames';
import CLASSNAMES from "./responsiveClassnames";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated
 * This component should not be used. Use tailwind classnames instead.
 */
var Text = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'body3' : _ref$type,
    htmlType = _ref.htmlType,
    _ref$as = _ref.as,
    Tag = _ref$as === void 0 ? 'span' : _ref$as,
    _ref$responsive = _ref.responsive,
    responsive = _ref$responsive === void 0 ? 'sm' : _ref$responsive,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'base-main' : _ref$color,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$truncate = _ref.truncate,
    truncate = _ref$truncate === void 0 ? false : _ref$truncate,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Tag, _objectSpread(_objectSpread({
    className: cn({
      truncate: truncate
    }, CLASSNAMES(responsive)[type], "text-".concat(color), className),
    ref: ref,
    type: htmlType,
    style: style
  }, other), {}, {
    children: children
  }));
});
Text.displayName = 'Text';
export default Text;